<div class="p-grid">
    <div class="p-col-12">
        <div class="p-d-flex p-jc-between">
            <h5 class="p-ml-3">{{reportName}}</h5>
            <p *ngIf="reportDate" class="p-mr-3">{{reportDate | date: 'short'}}</p>
            <p *ngIf="dateFrom && dateTo" class="p-mr-3"><strong>{{dateFrom | date: 'MM/dd/yyyy'}}</strong> to <strong>{{dateTo | date: 'MM/dd/yyyy'}}</strong></p>
        </div>
    </div>
</div>

<div class="p-grid" *ngIf="stackedBar.labels.length && stackedBar.datasets[0].data.length && !hideChart">
    <div class="p-col-12">
        <p-card>
            <div *ngIf="showChartFilters" class="p-d-flex">
                <p-dropdown
                    (onChange)="onChangeChartFilter($event)"
                    [options]="chartFilters"
                    [(ngModel)]="selectedChartType"
                    optionLabel="name"
                    placeholder="Select Any">
                </p-dropdown>
            </div>
            <div class="p-d-flex">
                <p style="writing-mode: vertical-lr;transform: rotate(180deg);text-align: center;" class="p-mb-0">{{selectedChartType?.name||'Geo Matched'}}</p>
                <div style="flex-grow:1; width:100%">
                    <p-chart type="bar" height="200px" [data]="stackedBar" [options]="stackedOptions"></p-chart>
                </div>
            </div>
        </p-card>
    </div>
</div>
